import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import logoDark from "../assets/images/logo.png";
import logoWhite from "../assets/images/logo_white.png";
import logolight from "../assets/images/logo_white.png";

export default function Navlight() {
  const [isOpen, setMenu] = useState(true);
  const [scroll, setScroll] = useState(false);

  useEffect(() => {
    activateMenu();
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 50);
    });
  }, []);

  const getClosest = (elem, selector) => {
    // Element.matches() polyfill
    if (!Element.prototype.matches) {
      Element.prototype.matches =
        Element.prototype.matchesSelector ||
        Element.prototype.mozMatchesSelector ||
        Element.prototype.msMatchesSelector ||
        Element.prototype.oMatchesSelector ||
        Element.prototype.webkitMatchesSelector ||
        function (s) {
          var matches = (this.document || this.ownerDocument).querySelectorAll(
              s
            ),
            i = matches.length;
          while (--i >= 0 && matches.item(i) !== this) {}
          return i > -1;
        };
    }

    // Get the closest matching element
    for (; elem && elem !== document; elem = elem.parentNode) {
      if (elem.matches(selector)) return elem;
    }
    return null;
  };

  const activateMenu = () => {
    var menuItems = document.getElementsByClassName("sub-menu-item");
    if (menuItems) {
      var matchingMenuItem = null;
      for (var idx = 0; idx < menuItems.length; idx++) {
        if (menuItems[idx].href === window.location.href) {
          matchingMenuItem = menuItems[idx];
        }
      }

      if (matchingMenuItem) {
        matchingMenuItem.classList.add("active");

        var immediateParent = getClosest(matchingMenuItem, "li");

        if (immediateParent) {
          immediateParent.classList.add("active");
        }

        var parent = getClosest(immediateParent, ".child-menu-item");
        if (parent) {
          parent.classList.add("active");
        }

        var parent = getClosest(parent || immediateParent, ".parent-menu-item");

        if (parent) {
          parent.classList.add("active");

          var parentMenuitem = parent.querySelector(".menu-item");
          if (parentMenuitem) {
            parentMenuitem.classList.add("active");
          }

          var parentOfParent = getClosest(parent, ".parent-parent-menu-item");
          if (parentOfParent) {
            parentOfParent.classList.add("active");
          }
        } else {
          var parentOfParent = getClosest(
            matchingMenuItem,
            ".parent-parent-menu-item"
          );
          if (parentOfParent) {
            parentOfParent.classList.add("active");
          }
        }
      }
    }
  };
  const toggleMenu = () => {
    setMenu(!isOpen);
    if (document.getElementById("navigation")) {
      const anchorArray = Array.from(
        document.getElementById("navigation").getElementsByTagName("a")
      );
      anchorArray.forEach((element) => {
        element.addEventListener("click", (elem) => {
          const target = elem.target.getAttribute("href");
          if (target !== "") {
            if (elem.target.nextElementSibling) {
              var submenu = elem.target.nextElementSibling.nextElementSibling;
              submenu.classList.toggle("open");
            }
          }
        });
      });
    }
  };
  return (
    <>
      <nav
        id="topnav"
        className={`${scroll ? "nav-sticky" : ""} defaultscroll is-sticky`}
      >
        <div className="container relative">
          <Link className="logo" to="/" style={{ padding: "5px" }}>
            <span className="inline-block dark:hidden">
              <img
                src={logoDark}
                className="l-dark"
                style={{ height: 85 }}
                alt=""
              />
              <img
                src={logoWhite}
                className="l-light"
                style={{ height: 85 }}
                alt=""
              />
            </span>
            <img
              src={logolight}
              className="hidden dark:inline-block"
              style={{ height: 85 }}
              alt=""
            />
          </Link>
          <div className="menu-extras">
            <div className="menu-item">
              <Link
                to=""
                className="navbar-toggle"
                id="isToggle"
                onClick={toggleMenu}
              >
                <div className="lines">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </Link>
            </div>
          </div>

          <div
            id="navigation"
            className={`${isOpen === true ? "hidden" : "block"}`}
          >
            <ul
              className="navigation-menu justify-end nav-light"
              style={{ padding: 10 }}
            >
              <li>
                <Link to="/" className="sub-menu-item">
                  Anasayfa
                </Link>
              </li>
              <li className="has-submenu parent-menu-item">
                <Link to="#">Hakkımızda</Link>
                <span className="menu-arrow"></span>
                <ul className="submenu">
                  <li>
                    <Link to="/hakkımızda" className="sub-menu-item">
                      Hakkımızda
                    </Link>
                  </li>
                  <li>
                    <Link to="/faaliyet-raporlarımız" className="sub-menu-item">
                      Faaliyet Raporlarımız
                    </Link>
                  </li>
                  <li>
                    <Link to="/yönetim-kadromuz" className="sub-menu-item">
                      Yönetim Kadromuz
                    </Link>
                  </li>
                  <li>
                    <Link to="/eğitmen-kadromuz" className="sub-menu-item">
                      Eğitmen Kadromuz
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <Link to="/faaliyetlerimiz" className="sub-menu-item">
                  Faaliyetlerimiz{" "}
                </Link>
              </li>

              <li>
                <Link to="/bloglar" className="sub-menu-item">
                  Blog
                </Link>
              </li>

              <li>
                <Link to="/iletişim" className="sub-menu-item">
                  İletişim
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}
